<template>
  <Cascader :value="areaIdList" :data="dataList" :load-data="loadData" @on-change="onTargetType"></Cascader>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'onTargetType'
  },
  props: {
    value: String
  },
  data() {
    return {
      dataList: [],
    }
  },
  computed: {
    areaIdList: function () {
      if (!this.value) return [];
      //   let provinceId = this.value.substring(0, 2) + '0000';
      //   let cityId = this.value.substring(0, 4) + '00';
      //   return [provinceId, cityId, this.value]
      return this.value
    }
  },
  created() {
    this.getDatalist()
  },
  methods: {
    async getDatalist() {
      let data = {
        url: 'CORE-TARGET/messageService/baseInfoService/queryAllTargetClasses',
        body: {}
      }
      await this.invoke(data).then(res => {
        this.dataList = res.map(({ code, name }) => {
          return { value: code, label: name, children: [], loading: false }
        })
      })
    },
    async loadData(item, callback) {
      item.loading = true;
      let data = {
        url: 'CORE-TARGET/messageService/baseInfoService/querySubTypes',
        body: { superCode: item.value }
      }
      let twoList = await this.invoke(data)
      item.children = twoList.map(({ code, name, typeLevel }) => {
        let obj = { value: code, label: name }
        if (typeLevel == "SORT") {
          obj.children = [];
          obj.loading = false;
        }
        return obj;
      })
      item.loading = false;
      callback();
    },
    onTargetType(val) {
      this.$emit('onTargetType', val[2])
    }
  }

}
</script>